import React, { useEffect, useState } from 'react';
import { CustomDialog } from '../../core/Dialogs/CustomDialog';
import { useTranslation } from '../../../contexts/translation';
import { LanguageChangerModal } from './LanguageChangerModal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function LanguageChanger({ isOpen, onClose }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <CustomDialog
        open={isOpen}
        title={t('general.language.modal-headline')}
        maxWidth={'xs'}
        onClose={onClose}
      >
        <LanguageChangerModal onClose={onClose} />
      </CustomDialog>
    </>
  );
}
